import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';

import { BatchesModel } from 'common/models/page-models/Batches/batches-data-model';
import { BatchesGridMetaModel } from 'common/models/page-models/Batches/batches-grid-meta-model';
import { BatchesListingModel } from 'common/models/page-models/Batches/batches-grid-model';
import { BatchesGridDataService } from 'common/services/data-services/admin/batches/batches-grid-data.services';



 
@Injectable({
    providedIn: 'root'
})
export class BatchesGridWidgetService extends GridWidgetService<BatchesModel, BatchesListingModel> {
    constructor(protected override ds: BatchesGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new BatchesGridMetaModel().getMetaModel();
        return meta;
    }
}